const crunchyrollDomains = [
  'crunchyroll.com',
  'www.crunchyroll.com',
  'beta.crunchyroll.com',
  'www.beta.crunchyroll.com',
  'stage.crunchyroll.com',
  'www.stage.crunchyroll.com',
  'beta-stage.crunchyroll.com',
  'www.beta-stage.crunchyroll.com',
  'cr.etp-proto0.com',
  'beta-cr.etp-proto0.com',
  'www.cr.etp-proto0.com',
  'www.beta-cr.etp-proto0.com',
  'cx.etp-proto0.com',
  'www.cx.etp-proto0.com',
];

export default crunchyrollDomains;
